'use client';
import { FC, PropsWithChildren, useEffect } from 'react';
import { Divider } from '../Divider';

type SubscriptionPageLayoutProps = PropsWithChildren<{
  childrenClasses?: string;
  showPaintstrokes?: boolean;
  containerClasses?: string;
  isSimplifiedSubflow?: boolean;
}>;

const SubscriptionPageLayout: FC<SubscriptionPageLayoutProps> = ({
  children,
  childrenClasses,
  containerClasses,
  isSimplifiedSubflow,
}) => {
  useEffect(() => {
    const mainElement = document.getElementById('main-layout');
    if (mainElement) {
      mainElement.classList.remove('min-h-screen');
    }
  }, []);

  return (
    <div className={`bg-tan-pastel ${containerClasses || ''}`}>
      {isSimplifiedSubflow && (
        <Divider
          backgroundImage={
            'url(https://images.ctfassets.net/0sea1vycfyqy/3ttC9tm04SEu6J5WKcSZHc/ac54c8612d8c86a3884978193abece47/Group_1750.png)'
          }
          className="h-3 md:h-6"
        />
      )}
      <div
        className={`flex flex-col mx-auto max-w-[1200px] px-6 pb-[150px] pt-6 md:px-10 md:pt-[88px] ${childrenClasses || ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default SubscriptionPageLayout;
